import React, { useState } from 'react'
import './styles.scss'
import { Isotype } from 'components/Isotype'
import { resident } from '../_svgpaths'
import { formatDate } from '../_utils'
import useDimensions from './useDimensions'

export const ActivityGroup = ({
  data,
  locales,
  date,
  isMobile
}: {
  data: { c: number; n: string }[]
  locales: { [key: string]: string }
  date: string
  isMobile: boolean | undefined
}) => {
  data.sort((a, b) => b.c - a.c)

  const [SVGEL, Size, Node] = useDimensions()
  const circleRad = Math.min(Size.width / (24 * 2), 8)||2
  const Circle = <circle r={circleRad} />
  const maincount = data.reduce((a, b) => a + b.c, 0)

  return (
    <div className='ActivityGroup'>
      <div className='grouptitle'>
        {maincount + ' ' + locales.groupactivities}{' '}
      </div>

      <div className='event'>
        <svg height='80px' width='100%' className='events' ref={SVGEL}>
          <Isotype
            data={[[...Array(maincount)].map(m => 'participant')]}
            x={6}
            y={17}
            xOffset={circleRad * 2}
            yOffset={isMobile ? circleRad * 2 : circleRad * 6}
            icon={isMobile ? Circle : <path d={resident} />}
            wrapAfter={20}
          />
        </svg>
      </div>
      {/* {data.map(event => {
        const { n, c } = event
        const [SVGEL, Size, Node] = useDimensions()
        const circleRad = Math.min(Size.width / (24 * 2), 8)
        const Circle = <circle r={circleRad} />

        return (
          <div className='event'>
            <div className='name'>
              {n}
              <br />
              <span>
                {c} {locales.participant}
              </span>
            </div>
            <svg height='40px' className='events' ref={SVGEL}>
              <Isotype
                data={[[...Array(c)].map(m => 'participant')]}
                x={6}
                y={17}
                xOffset={circleRad * 3}
                yOffset={10}
                icon={
                  isMobile ? (
                    Circle
                  ) : (
                    <path d={resident} transform={`scale(0.7)`} />
                  )
                }
                wrapAfter={14}
              />
            </svg>
          </div>
        )
      })} */}
    </div>
  )
}
